<div class="page">
  <h1 class="page-title">
    CONTRATO DE PRESTAÇÃO DE SERVIÇOS EM PROCESSAMENTO, CRIOGENIA E
    ARMAZENAMENTO DE MATERIAL BIOLÓGICO – DOCUMENTO DE ANUÊNCIA
  </h1>
  <br />
  <p [hidden]="coletaValida" class="invalid">RASCUNHO</p>
  <p class="page-paragrafo">
    Nº do CONTRATO: <strong>{{ coletor.codigo || "" }}</strong>
  </p>
  <hr />
  <p class="page-paragrafo">
    São Partes no presente Instrumento:
    <br />

    I) de um lado, <strong>CURITIBA BIOTECNOLOGIA LTDA</strong>., sociedade por
    quotas de responsabilidade limitada, nome fantasia
    <strong>CURITYBA BIOTECH</strong>, com sede na Rua Prof. Pedro Viriato
    Parigot de Souza, 5300, Bloco Marrom, 1° andar, sala 111, Campo Comprido,
    CEP 81.280-330, Curitiba-PR, Brasil, inscrita no CNPJ/MF sob o n°
    10.313.059/0001-93, e, inscrita no CRO-PR sob n° 3360 e CRM-PR sob n° 10133,
    por seu representante legal, doravante denominada
    <strong>CONTRATADA</strong>; e
    <br />
    II) de outro lado:
  </p>

  <p class="page-paragrafo">
    <span [hidden]="!maiorDeIdade">
      {{ nomeContrantante }}: <strong>{{ doador.nome || campoVazio }}</strong
      >,
      <span [hidden]="maiorDeIdade">
        Grau de parentesco: <strong> {{ "" }}, </strong>
      </span>
      CPF/MF nº: <strong>{{ doador.cpf || campoVazio }}</strong
      >, RG nº: <strong>{{ doador.rg || campoVazio }}</strong
      >, Data de nascimento:
      <strong>{{ dataNascimentoDoador || campoVazio }}</strong
      >, Estado Civil: <strong>{{ doador.estadoCivil || campoVazio }}</strong
      >, Nacionalidade: <strong>{{ doador.nacionalidade || campoVazio }}</strong
      >, Profissão: <strong>{{ doador.profissao || campoVazio }}</strong
      >, Endereço: <strong>{{ doador.endereco || campoVazio }}</strong
      >, n°: <strong>{{ doador.numEndereco || campoVazio }}</strong
      >, Bairro: <strong>{{ doador.bairro || campoVazio }}</strong
      >, Município: <strong>{{ doador.cidade || campoVazio }}</strong
      >, Estado: <strong>{{ doador.estado || campoVazio }}</strong
      >, CEP
      <strong>{{ coletor.cepResponsavel1 || doador.cep || campoVazio }}</strong
      >, Tel. Celular:
      <strong>{{ doador.telefoneCelular || campoVazio }}</strong
      >, E-mail: <strong>{{ doador.email || campoVazio }}</strong>
    </span>
    <br />
    <span [hidden]="maiorDeIdade">
      {{ nomeContrantante }}:
      <strong>{{ coletor.nomeResponsavel1 || campoVazio }}</strong
      >, Grau de parentesco:
      <strong>{{ coletor.grauParentescoResp1 || "" }}</strong
      >, CPF/MF nº: <strong>{{ coletor.cpfResponsavel1 || campoVazio }}</strong
      >, RG nº: <strong>{{ coletor.rgResponsavel1 || campoVazio }}</strong
      >, Data de nascimento:
      <strong>{{ dataNascimentoResp1 || campoVazio }}</strong
      >, Estado Civil:
      <strong>{{ coletor.estadoCivilResp1 || campoVazio }}</strong
      >, Nacionalidade:
      <strong>{{ coletor.nacionalidadeResp1 || campoVazio }}</strong
      >, Profissão: <strong>{{ coletor.profissaoResp1 || campoVazio }}</strong
      >, Endereço:
      <strong>{{ coletor.enderecoResponsavel1 || campoVazio }}</strong
      >, n°: <strong>{{ coletor.numEnderecoResponsavel1 || campoVazio }}</strong
      >, Bairro:
      <strong>{{
        coletor.bairroResponsavel1 || doador.bairro || campoVazio
      }}</strong
      >, Município:
      <strong>{{ coletor.cidadeResponsavel1 || campoVazio }}</strong
      >, Estado: <strong>{{ coletor.estadoResponsavel1 || campoVazio }}</strong
      >, CEP <strong>{{ coletor.cepResponsavel1 || campoVazio }}</strong
      >, Tel. Celular:
      <strong>{{ coletor.telefoneCelularResponsavel1 || campoVazio }}</strong
      >, E-mail: <strong>{{ coletor.emailResponsavel1 || campoVazio }}</strong>

      <span [hidden]="semResponsavel2">
        <br />
        e,
        <br />
        Nome do CONTRATANTE 2:
        <strong>{{ coletor.nomeResponsavel2 || campoVazio }}</strong
        >, Grau de parentesco:
        <strong>{{ coletor.grauParentescoResp2 || campoVazio }}</strong
        >, CPF/MF nº:
        <strong>{{ coletor.cpfResponsavel2 || campoVazio }}</strong
        >, RG nº: <strong>{{ coletor.rgResponsavel2 || campoVazio }}</strong
        >, Data de nascimento:
        <strong>{{ dataNascimentoResp2 || campoVazio }}</strong
        >, Estado Civil:
        <strong>{{ coletor.estadoCivilResp2 || campoVazio }}</strong
        >, Nacionalidade:
        <strong>{{ coletor.nacionalidadeResp2 || campoVazio }}</strong
        >, Profissão: <strong>{{ coletor.profissaoResp2 || campoVazio }}</strong
        >, Endereço:
        <strong>{{ coletor.enderecoResponsavel2 || campoVazio }}</strong
        >, n°:
        <strong>{{ coletor.numEnderecoResponsavel2 || campoVazio }}</strong
        >, Bairro:
        <strong>{{ coletor.bairroResponsavel2 || campoVazio }}</strong
        >, Município:
        <strong>{{ coletor.cidadeResponsavel2 || campoVazio }}</strong
        >, Estado:
        <strong>{{ coletor.estadoResponsavel2 || campoVazio }}</strong
        >, CEP <strong>{{ coletor.cepResponsavel2 || campoVazio }}</strong
        >, Tel. Celular:
        <strong>{{ coletor.telefoneCelularResponsavel2 || campoVazio }}</strong
        >, E-mail:
        <strong>{{ coletor.emailResponsavel2 || campoVazio }}</strong>
      </span>
    </span>
  </p>

  <p class="page-paragrafo"></p>

  <p class="page-paragrafo">
    Nome do BENEFICIÁRIO (Paciente): <strong>{{ doador.nome }}</strong
    >, CPF/MF n°: <strong>{{ doador.cpf || campoVazio }}</strong
    >, RG n°: <strong>{{ doador.rg || campoVazio }}</strong
    >, Data de nascimento:
    <strong>{{ dataNascimentoDoador || campoVazio }}</strong
    >, Estado Civil: <strong>{{ doador.estadoCivil || campoVazio }}</strong
    >, Nacionalidade: <strong>{{ doador.nacionalidade || campoVazio }}</strong
    >, Profissão: <strong>{{ doador.profissao || campoVazio }}</strong
    >, Endereço: <strong>{{ doador.endereco || campoVazio }}</strong
    >, n°: <strong>{{ doador.numEndereco || campoVazio }}</strong
    >, Bairro: <strong>{{ doador.bairro || campoVazio }}</strong
    >, Município: <strong>{{ doador.cidade || campoVazio }}</strong
    >, CEP <strong>{{ doador.cep || campoVazio }}</strong
    >, Tel. Celular: <strong>{{ doador.telefoneCelular || campoVazio }}</strong
    >, E-mail: <strong>{{ doador.email || campoVazio }}</strong>
  </p>

  <p class="page-paragrafo">
    <strong
      ><u>Profissional responsável pela coleta: </u>
      {{ credenciadoNome }}</strong
    >
    <br /><br />
    doravante denominados conjuntamente como <strong>CONTRATANTES</strong>,
    ambos, integrando o presente na qualidade de representantes legais (quando o
    beneficiário for menor ou incapaz), o qual doravante será denominado
    simplesmente como <strong>BENEFICIÁRIO</strong>,<br /><br />
    têm entre si pactuado, na melhor forma de direito, o presente Contrato, em
    concordância com o conteúdo descrito no
    <strong
      >CONTRATO DE PRESTAÇÃO DE SERVIÇOS EM PROCESSAMENTO, CRIOGENIA
      ARMAZENAMENTO DE MATERIAL BIOLÓGICO</strong
    >, integrante inseparável a este documento, concordam com a realização da
    prestação de serviço de transporte, processamento, criopreservação, com ou
    sem armazenamento de material biológico com o intuito de preservação de
    células e seus subprodutos
  </p>

  <footer class="text-center">1 de 2</footer>
</div>

<div class="page" style="margin-top: 80px">
  <p [hidden]="coletaValida" class="invalid">RASCUNHO</p>
  <p class="page-paragrafo">
    Declaramos que o valor ora pactuado neste Contrato é de:
    <br />
    Taxa de Contrato: <strong>R$ {{ taxaContratoFormatada }}</strong>
    <span>
      (<strong>{{ taxaPorExtenso }}</strong
      >)</span
    >

    <br />
    demais despesas em decorrência deste serviço e demais serviços contratados
    serão detalhados em TERMO ADITIVO E/OU ORDEM DE SERVIÇO.
    <br /><br />
    Curitiba,
    <span
      ><strong>{{ dataHoraFinalizacao() }}</strong></span
    >
  </p>

  <br /><br />

  <span>_____________________________________________</span>
  <span style="padding-left: 20px" [hidden]="maiorDeIdade || semResponsavel2">{{
    linhaAssinatura
  }}</span>
  <br />

  <div class="container">
    <p style="text-align: center" [hidden]="!maiorDeIdade">{{ doador.nome }}</p>
    <p style="text-align: center" [hidden]="maiorDeIdade">
      {{ coletor.nomeResponsavel1 }}
    </p>
    <p style="text-align: center" [hidden]="maiorDeIdade || semResponsavel2">
      {{ coletor.nomeResponsavel2 || coletor.nomeResponsavel1 }}
    </p>
  </div>

  <br />
  <span>_____________________________________________</span>
  <span style="padding-left: 20px"
    >_____________________________________________</span
  >
  <br />
  <div class="container">
    <p style="text-align: center">{{ credenciadoNome }}</p>
    <p style="text-align: center">CURITIBA BIOTECNOLOGIA LTDA</p>
  </div>
  <br /><br />

  <p style="text-align: center">TESTEMUNHAS</p>
  <br /><br />
  <p class="page-paragrafo">
    1- NOME:
    <br />
    ASSINATURA: __________________________________________
    <br />
    CPF:
    <br />
    RG:
    <br />
    ENDEREÇO:
    <br />
    CEP:

    <br /><br />
    2- NOME:
    <br />
    ASSINATURA: __________________________________________
    <br />
    CPF:
    <br />
    RG:
    <br />
    ENDEREÇO:
    <br />
    CEP:
  </p>

  <footer class="text-center">2 de 2</footer>
</div>
